type Variant = "primary" | "white" | "dark" | "black";

const palettes: Record<Variant, { dark: string; light: string }> = {
  primary: { dark: "#991B1B", light: "#DC2626" },
  white:   { dark: "#FFFFFF", light: "#FECACA" },
  dark:    { dark: "#DC2626", light: "#F87171" },
  black:   { dark: "#111827", light: "#374151" },
};

const LogoIcon = ({ size = 32, variant = "primary", className = "" }: {
  size?: number;
  variant?: Variant;
  className?: string;
}) => {
  const c = palettes[variant];
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className} aria-label="Mali Ajanda Logo">
      <rect x="14" y="30" width="12" height="55" rx="3" fill={c.dark}/>
      <rect x="29" y="50" width="12" height="35" rx="3" fill={c.light}/>
      <rect x="44" y="20" width="12" height="65" rx="3" fill={c.dark}/>
      <rect x="59" y="50" width="12" height="35" rx="3" fill={c.light}/>
      <rect x="74" y="30" width="12" height="55" rx="3" fill={c.dark}/>
    </svg>
  );
};

export default LogoIcon;
